var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFemale = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  fill: "none",
  viewBox: "0 0 80 80"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M36.667 70v-6.667H30v-6.666h6.667v-7q-6.583-1.167-10.792-6.292T21.667 31.5q0-7.583 5.375-12.875T40 13.333t12.959 5.292T58.334 31.5q0 6.75-4.209 11.875t-10.791 6.292v7H50v6.666h-6.666V70zM40 43.333q4.833 0 8.25-3.416t3.417-8.25q0-4.835-3.417-8.25Q44.833 20 40 20t-8.25 3.417q-3.416 3.415-3.416 8.25 0 4.833 3.416 8.25T40 43.333"
})));
export default SvgFemale;